import { render, staticRenderFns } from "./actualCombat.vue?vue&type=template&id=5fc06475&scoped=true"
import script from "./actualCombat.vue?vue&type=script&lang=js"
export * from "./actualCombat.vue?vue&type=script&lang=js"
import style0 from "./actualCombat.vue?vue&type=style&index=0&id=5fc06475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc06475",
  null
  
)

export default component.exports